// extracted by mini-css-extract-plugin
export default {"notice":"VerificationModal-module__notice--owj2m","hr":"VerificationModal-module__hr--YnI9C","animatedBackground":"VerificationModal-module__animatedBackground--kQMJ_"};